import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';


@Component({
  standalone: false,
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.css']
})
export class OtpInputComponent {

    @Input() form: any;
    @Input() formCtrl!: any;

    @ViewChild('ngOtpInput') ngOtpInputRef:any;

    @Output() modify: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {}

    reset(){
        this.ngOtpInputRef.setValue(null);
    }

    onOtpChange(event: any){
        this.form.get(this.formCtrl).setValue(event);

        if(event){
            this.modify.emit(event);
        }
    }
}
